import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            数字系列视频平台
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            七大平台，海量资源，总有一个适合你。点击进入，即刻畅享高清观影体验。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat, index) => {
            const colorClasses = index % 3 === 0
              ? 'bg-primary-50 border-primary-200/50 hover:border-primary-300'
              : index % 3 === 1
              ? 'bg-accent-50 border-accent-200/50 hover:border-accent-300'
              : 'bg-secondary-50 border-secondary-200/50 hover:border-secondary-300';

            const iconColor = index % 3 === 0
              ? 'text-primary-500'
              : index % 3 === 1
              ? 'text-accent-500'
              : 'text-secondary-500';

            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className={`group p-5 md:p-6 rounded-xl border transition-all duration-300 cursor-pointer ${colorClasses}`}
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg bg-background-50 mb-4 ${iconColor}`}>
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}